module.exports = __webpack_public_path__ + "img/Abecedario.e46fcea7.svg";